import { PureAmount } from './pure/component.js';
import { Amount as Amount$1 } from './component.js';

var Amount = Amount$1;
Amount.Pure = PureAmount;

export { Amount };
